import { mapApiAgentToDetailView } from "../../../../../utils/agentMappers";

export function buildAgentDetailView(agent) {
  return mapApiAgentToDetailView(agent);
}
